export enum UserActionType {
  LOGIN = "LOGIN",
  APP_SESSION = "APP_SESSION",
  DATA_SYNC = "DATA_SYNC",
  DATA_UPDATE = "DATA_UPDATE",
  REVIEW_RESPONSE = "REVIEW_RESPONSE",
  DEMO_CALENDAR_INTERACT = "DEMO_CALENDAR_INTERACT",
  DEMO_REVIEW_SELECT = "DEMO_REVIEW_SELECT",
  DEMO_REVIEW_AI_GENERATE = "DEMO_REVIEW_AI_GENERATE",
  DEMO_REVIEW_PUBLISH = "DEMO_REVIEW_PUBLISH",
  DEMO_REQUEST = "DEMO_REQUEST",
  DEMO_SCHEDULE = "DEMO_SCHEDULE",
  DEMO_ACTIVATE_VISIBILITY = "DEMO_ACTIVATE_VISIBILITY",
  DEMO_CREATION = "DEMO_CREATION",
  DEMO_OUVERTURE = "DEMO_OUVERTURE",
  CALENDRIER_OUVERTURE = "CALENDRIER_OUVERTURE",
  KB_CONSULTATION = "KB_CONSULTATION",
  KB_MODIFICATION = "KB_MODIFICATION",
}

export const APP_SESSION_STORAGE_KEY = "uska_app_session_tracked"
export const NOVA_LOGIN_STORAGE_KEY = "uska_nova_login"
